<template>
	<div>
		<form @submit.prevent="validateAndSubmit">

			<!-- <input-text v-if="subscription_options.frequency_payment === 0" v-model="model.days" name="sub_options_days" :placeholder="$t('labels.general.days')" rules="required|numeric|decimal:0|min_value:1"/> -->
			<!-- <input-text v-model="subscription_options.units" name="sub_options_units" :placeholder="$t('labels.general.units')" rules="required|numeric|decimal:0|min_value:1"/> -->

			<section>
				<main>
					<h1>{{ nameLabel }}</h1>
					<p>{{ descriptionLabel }}</p>
				</main>
			</section>

			<input-range v-model="subscription_options.units" name="sub_options_units" :placeholder="$t('labels.general.units')" min="1" max="25"/>
			<div class="e-unity">{{ units }}</div>

			<input-radio-v2 v-model="subscription_options.frequency_payment" :options="options" name="sub_options_payment_frequency" :placeholder="$t('labels.general.payment_frequency')" rules="required" />
			<input-toggle v-model="subscription_options.auto_renew" name="sub_options_auto_renew" :placeholder="$t('labels.general.auto_renew')" rules="required"/>

			<label class="e-label">Base</label>
			<div class="e-total">{{ totalBase }}€</div>

			<label class="e-label">Tax</label>
			<div class="e-total">{{ totalTax }}€</div>

			<label class="e-label">Total</label>
			<div class="e-total">{{ total }}€ <span class="e-total-sufix">{{ paymentFrequency }}</span></div>

			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('labels.general.subscribe') }}</button-submit-icon-text>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'service',
		'subscription_options',
		'form'
	],
	data () {
		return {
			name: 'subscription add',
			options: [
				{ text: this.$t('labels.general.monthly'), value: -1 },
				{ text: this.$t('labels.general.yearly'), value: -2 },
				//{ text: this.$t('labels.general.daily'), value: 0 }
			]
		}
	},
	computed: {
		nameLabel() {
			if (this.subscription_options !== null && this.service !== null) {
				return this.service.name
			}
			return ''
		},
		descriptionLabel() {
			if (this.subscription_options !== null && this.service !== null) {
				return this.service.description
			}
			return ''
		},
		priceBaseUnity() {
			if (this.subscription_options.frequency_payment == -2) {
				return this.service.yearly_price_base_unity
			}
			return this.service.monthly_price_base_unity
		},
		priceTaxUnity() {
			if (this.subscription_options.frequency_payment == -2) {
				return this.service.yearly_tax_unity
			}
			return this.service.monthly_tax_unity
		},
		priceUnity() {
			if (this.subscription_options.frequency_payment == -2) {
				return this.service.yearly_price_unity
			}
			return this.service.monthly_price_unity
		},
		totalBase() {
			if (this.subscription_options !== null && this.service !== null) {
				const value = this.subscription_options.units * this.priceBaseUnity
				return parseFloat(value).toFixed(2)
			}
			return 0
		},
		totalTax() {
			if (this.subscription_options !== null && this.service !== null) {
				const value = this.subscription_options.units * this.priceTaxUnity
				return parseFloat(value).toFixed(2)
			}
			return 0
		},
		total() {
			if (this.subscription_options !== null && this.service !== null) {
				const value = this.subscription_options.units * this.priceUnity
				return parseFloat(value).toFixed(2)
			}
			return 0
		},
		paymentFrequency() {
			if (this.subscription_options.frequency_payment == -2) {
				return 'by year'
			}
			return 'by month'
		},
		units() {
			if (this.subscription_options.units > 1) {
				return this.subscription_options.units + ' units'
			}
			return this.subscription_options.units + ' unity'
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.$emit('success')
			})
		}
	}
}
</script>

<style scoped>
	.e-label {
		color: var(--main-color);
		font-family: var(--font-bold);
		text-align: left;
		height: auto;
		margin: 10px 0 0 0;
	}

	.e-total {
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/SubscriptionFormOptions.vue